import { useState, useEffect, useRef } from 'react';

import Logger from "../utils/logger";

const log = Logger.create("useUserLocation");

const API_KEY = process.env.REACT_APP_IP_API_KEY ;

export default function useUserLocation() {
  const [location, setLocation] = useState(null);  
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);        
  const gotGPSRef = useRef(false);           
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;      
    initializedRef.current = true;
    fetchIPLocation();

    if (!navigator.geolocation) {
      log.log("Going to fetchIPLocation");
      fetchIPLocation();
      setError('This browser does not support Geolocation.');
      return;
    }
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        gotGPSRef.current = true;
        setLocation(prev => ({
          ...prev,
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          source: 'GPS',
        }));
        setLoading(false);
      },
      (err) => {
        fetchIPLocation();
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
    
  }, []);

  // IPregistry
  const fetchIPLocation = async () => {
    try {
      const res = await fetch(`https://api.ipregistry.co/?key=${API_KEY}`);
      const data = await res.json();

      if (gotGPSRef.current) {
        log.log("GPS already available, skip IP location update");
        return;
      }

      setLocation({
        lat: parseFloat(data.location?.latitude), 
        lng: parseFloat(data.location?.longitude), 
        city: data.location?.city,
        region: data.location?.region?.name,
        country: data.location?.country?.name,
        postal: data.location?.postal,
        ip: data.ip,
        source: 'IP',
      });
      setLoading(false);
    } catch (e) {
      setError(`IPregistry Error: ${e.message}`);
      setLoading(false);
    }
  };


  return { location, error, loading };
}